<template>
  <div class="card text-center">
    <v-icon size="120">mdi-file-check</v-icon>

    <div class="items-list" no-gutters>
      <div class="d-flex justify-space-between py-1">
        <p class="title">NÚMERO DO DOCUMENTO</p>
        <p class="value">{{ receipt.documentNumber }}</p>
      </div>
    </div>
    <div class="items-list" no-gutters>
      <div class="d-flex justify-space-between py-1">
        <p class="title">CARTÂO</p>
        <p class="value">{{ receipt.typeCard }}</p>
      </div>
    </div>
    <div class="items-list" no-gutters>
      <div class="d-flex justify-space-between py-1">
        <p class="title">BANDEIRA</p>
        <p class="value">{{ receipt.flagCard }}</p>
      </div>
    </div>
 
    <div class="items-list" no-gutters>
      <div class="d-flex justify-space-between py-1">
        <p class="title">MODO DE PAGAMENTO</p>
        <p class="value">{{ receipt.modePay }}</p>
      </div>
    </div>
    <div class="items-list" no-gutters>
      <div class="d-flex flex-column justify-start align-content-start py-1">
        <p class="title text-left">FATURA(S)</p>
        <div
          class="d-flex justify-space-between"
          v-for="(invoice, index) in invoices"
          :key="index"
        >
          <p class="value">{{ invoice.due_date | filterDatePT }}</p>
          <p class="value">
            {{ invoice.value_up | filterFormatNumberRealFormat }}
          </p>
        </div>
      </div>
    </div>

    <div class="items-list" no-gutters>
      <div class="d-flex justify-space-between py-1">
        <p class="title">TOTAL PAGO</p>
        <p class="value">{{ valueUp | filterFormatNumberRealFormat }}</p>
      </div>
    </div>

    <v-btn
      block
      class="py-7 mt-5 payment-button"
      color="primary"
      @click="handlePrintReceipt"
      @click.right="handlePrintReceipt"
    >
      Imprimir comprovante
    </v-btn>

    <v-btn
      block
      class="py-7 mt-5 payment-button"
      color="secondary"
      @click="handleSendReceipt"
      @click.right="handleSendReceipt"
    >
      Enviar comprovante por e-mail
    </v-btn>

    <v-divider class="my-10"></v-divider>
    <v-btn
      block
      class="py-7 mt-5 payment-button"
      @click="goBack"
      @click.right="goBack"
      color="white"
      ><v-icon class="pr-4">mdi-arrow-left</v-icon> voltar</v-btn
    >
    <v-btn
      v-if="isEndTheSession"
      block
      class="py-7 mt-5 payment-button"
      color="primary"
      @click="userLogout"
      @click.right="userLogout"
    >
      Encerrar sessão
    </v-btn>
  </div>
</template>

<script>
import { getDateToPT } from "@/services/date.service";
import { formatNumberReal } from "@/services/formatNumber.service";

export default {
  props: {
    receipt: {
      type: Object,
      required: true,
    },
    invoices: {
      type: Array,
      required: true,
    },
    valueUp: {
      type: String,
      required: true,
    },
    isEndTheSession: {
      type: Boolean,
      default: false,
    }
  },
  filters: {
    filterFormatNumberRealFormat(value) {
      return formatNumberReal(Number(value));
    },
    filterDatePT(date) {
      return getDateToPT(date);
    },
  },
  methods: {
    handlePrintReceipt() {
      this.$emit("handlePrintReceipt");
    },
    handleSendReceipt() {
      this.$emit("handleSendReceipt");
    },
    goBack() {
      this.$emit("goBack");
    },
    userLogout() {
      this.$emit("userLogout");
    }
  },
};
</script>

<style scoped>
.items-list {
  border-bottom: 2px solid rgba(22, 33, 45, 0.12);
}
.items-list:last-of-type {
  border-bottom: 0 !important;
}
.title,
.value {
  margin: 0;
  font-size: 16px !important;
  color: rgba(22, 33, 45, 0.6);
  font-weight: 600;
}
.value {
  color: rgba(22, 33, 45, 1);
}
.fullscreen-dialog .payment-button {
  box-shadow: 0px 4px 0px rgba(255, 255, 255, 0.4),
    0px 6px 16px rgba(35, 41, 46, 0.2) !important;
  border-radius: 16px !important;
  font-weight: 600 !important;
  font-size: 17px !important;
}
</style>